// extracted by mini-css-extract-plugin
export default {"page":"Act_page__vN3oI","text":"Act_text__ydBiv","success":"Act_success__SSVRx"};